import { IconSvg, IconSvgProps } from "./icon"

export default function Plus(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 3.694V20.41M3.643 12h16.714" />
    </IconSvg>
  )
}
